import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/colors.ejs';
import { pickerCfg } from 'pickerCfg';
import util             from 'util/Util.js';
import themeService     from 'ThemeService.js';
import Immutable                from 'immutable'; 
import listService from 'ListService';
import constants        from 'Constants';
class StyleColorsView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=color]': 'updateColorAttributes',
            'change input[type=text]': 'updateColorAttributesWithValidation'
        };

        let mobileDesignerStyle = listService.mainKind === constants.KIND_MOBILE ? "display: none;" : "";
        this.model.set('mobileDesignerStyle', mobileDesignerStyle, constants.MODEL_SILENT);

        return this;
    }

    render() {
        super.render();

        let props = this.resolveThemeColors(this.model, ['styleColorText', 'styleColorTextDown', 'styleColorTextOver']);
        const alignRightBI = Immutable.Set(['control_clear_filter_button','control_print_button', 'control_submit_button']);    
        props.alignRightBI = alignRightBI;    

        this.$el.html(this.template(props));

        this.delegateEvents();

        return this;
    }

}

export default StyleColorsView;
